'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CookieWrap = /** @class */ (function () {
    function CookieWrap() {
    }
    CookieWrap.prototype.get = function (name) {
        var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    };
    CookieWrap.prototype.set = function (name, value, options) {
        if (options === void 0) { options = {}; }
        var expires = options.Expires;
        if (typeof expires === 'number' && expires) {
            var d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.Expires = d;
        }
        if (expires instanceof Date) {
            options.Expires = expires.toUTCString();
        }
        value = encodeURIComponent(value);
        var updatedCookie = name + '=' + value;
        for (var propName in options) {
            updatedCookie += '; ' + propName;
            // @ts-ignore
            var propValue = options[propName];
            if (propValue !== true) {
                updatedCookie += '=' + propValue;
            }
        }
        document.cookie = updatedCookie;
    };
    CookieWrap.prototype.del = function (name) {
        this.set(name, '', {
            Expires: -1,
        });
    };
    return CookieWrap;
}());
var cookieSrv = new CookieWrap();

exports.CookieWrap = CookieWrap;
exports.cookieSrv = cookieSrv;
